
































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { ProductsApi } from '../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		Toast,
	},
	mixins: [validationMixin],
})
export default class AddNote extends Vue {
	public loading = false;

	@PropSync('product') public localProduct!: {
		type: 'milk';
		supplier: 'F';
	};

	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	private api: ProductsApi = new ProductsApi();

	public async onComplete() {
		this.submitStatus = 'PENDING';
		const productId = this.localProduct.id;
		try {
			this.api.updateProduct(parseInt(productId, 10), {
				data: { orgId: this.localProduct.orgId, notes: this.localProduct.notes || '' },
			});
		} catch (e) {
			let error;
			if (e.response) {
				if (e.response.data.message) {
					error = 'Note not created ' + e.response.data.message;
				}
			} else if (e.request) {
				error = 'Note not created, network Error';
			} else {
				error = 'Note not created, unknown Error';
			}
			new Toast().makeToast(error, 'Error Creating Note', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'OK';
		new Toast().makeToast('Note has been added to the product', 'Note Added', 'success');
		this.$bvModal.hide('noteModal');
		setTimeout(() => this.$emit('loadNote'), 1000);
		this.notes = '';
	}
}
